import { SidenavBaseFilterComponent } from '../../../../../core/base/components/sidenav/base-filter/sidenav-base-filter.component';
import { PRODUCT_DISTINCT_FILTERS, PRODUCT_FILTER_SCHEMA } from './product-filter.schema';
import { AutocompleteService } from '../../../../../core/services/scroll.service';
import { AuthService } from '../../../../../core/services/auth.service';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SupplierService } from '../../supplier/supplier.service';
import { GenericProductService } from '../../../settings/generic-product/generic-product.service';
import { ProductService } from '../product.service';

@Component({
  selector: 'product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.scss'],
})
export class ProductFilterComponent extends SidenavBaseFilterComponent {
  override readonly schema = PRODUCT_FILTER_SCHEMA;
  readonly distinctFilters = PRODUCT_DISTINCT_FILTERS;
  // Champ (et non options inline dans le template) : la restauration retrouve l'objet d'option par référence
  suspensionOptions = [
    { label: 'Oui', value: true },
    { label: 'Non', value: false },
  ];

  constructor(
    public authService: AuthService,
    public snackbarService: SnackbarService,
    public autocompleteService: AutocompleteService,
    public supplierService: SupplierService,
    public genericProductService: GenericProductService,
    public productService: ProductService,
  ) {
    super(snackbarService, autocompleteService);

    this.addForm(
      'standardForm',
      new UntypedFormGroup({
        technicalIdentifier: new UntypedFormControl(),
        reference: new UntypedFormControl(),
        genericProducts: new UntypedFormControl(),
        suppliers: new UntypedFormControl(),
        ...Object.fromEntries(PRODUCT_DISTINCT_FILTERS.map(({ control }) => [control, new UntypedFormControl()])),
        isSuspended: new UntypedFormControl(),
      }),
    );
  }

  initialize() {
    this.autocompleteSuppliers();
    this.autocompleteGenericProducts();
    PRODUCT_DISTINCT_FILTERS.forEach(({ field }) => this.autocompleteProductsFields('', field));
  }

  autocompleteSuppliers(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'suppliers', '_id', pageToGo, (page, size) =>
        this.supplierService.findAll(page, size, 'label', 'asc', search),
      )
      ?.subscribe();
  }

  autocompleteGenericProducts(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'genericProducts', '_id', pageToGo, (page, size) =>
        this.genericProductService.findAll(page, size, 'label', 'asc', search, {}, 'generics'),
      )
      ?.subscribe();
  }

  autocompleteProductsFields(search: string = '', filterName: string, pageToGo?: 'next' | 'previous') {
    const data = this.autocompleteService.autocompleteInfiniteScroll(
      search,
      filterName,
      filterName,
      pageToGo,
      (page, size) =>
        this.productService.findAll(page, size, filterName, 'asc', search, {
          onlyDistinctField: filterName,
          requiredFields: [filterName],
        }),
    );

    data.subscribe();
  }

  onScrollLine(pageToGo: 'next' | 'previous', filterField: string) {
    switch (filterField) {
      case 'genericProducts':
        this.autocompleteGenericProducts('', pageToGo);
        break;
      case 'suppliers':
        this.autocompleteSuppliers('', pageToGo);
        break;
      default:
        if (PRODUCT_DISTINCT_FILTERS.some(({ field }) => field === filterField)) {
          this.autocompleteProductsFields('', filterField, pageToGo);
        } else {
          console.error('Unknown filterField:', filterField);
        }
    }
  }
}
